import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";

// Applies a list of commands as one history entry, so a bulk action (e.g. a
// section's "Take all resolvable") is a single undo. Returns true if any
// child mutated the model.
export class BatchCommand extends CommandBase {
    commands: CommandBase[];

    constructor(commands: CommandBase[]) {
        super();
        this.commands = commands;
    }

    execute(data: RemoteConstantsModel): boolean {
        let mutated = false;
        for (const c of this.commands) {
            if (c.execute(data)) mutated = true;
        }
        return mutated;
    }
}
